export const EShapeActionValueMiscType = wcardinal.ui.EShapeActionValueMiscType;